var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ja-content',{attrs:{"pageTitle":_vm.$t("audiences")}},[(_vm.audiences.length)?_c('ja-data-table',{attrs:{"fields":_vm.fields,"items":_vm.audiences,"pagination":_vm.pagination,"on-change-page":_vm.handleChangePage,"on-row-click":(row) => _vm.jaDetailView("audience", row)}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }